import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const Products: ParentMenuProps = {
  label: 'Products',
  description: 'Run your business with online ordering, payroll, and more',
  heapClass: 'topnav_pdps_v',
  showcaseMobile: true,
  showcaseEntries: [
    {
      title: 'Online Ordering',
      description:
        'A commission-free solution, totally integrated with your POS for real-time updates.',
      heapClass: 'navspotlight1_oo_v',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/online-ordering-thumbnail.png',
      badge: {
        label: 'Popular',
        color: 'bg-yellow-25'
      },
      icon: 'before:content-icon-online-ordering-mobile',
      url: '/products/online-ordering'
    },
    {
      title: 'Payroll Suite',
      description: 'Fast, easy payroll synced right with your POS.',
      heapClass: 'navspotlight2_payroll_v',
      thumbnail:
        'https://d2w1ef2ao9g8r9.cloudfront.net/images/images/payroll-suite-thumbnail.png',
      badge: {
        label: 'Popular',
        color: 'bg-yellow-25'
      },
      icon: 'before:content-icon-software-payroll',
      url: '/products/payroll'
    }
  ],
  subMenus: [
    {
      label: 'Operations Suite',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Point of Sale',
          icon: 'before:content-icon-hardware-flex',
          badge: {
            label: 'Start Here',
            color: 'bg-grass-25'
          },
          url: '/products/point-of-sale',
          heapClass: 'nav_pos_v'
        },
        {
          label: 'Payment Processing',
          icon: 'before:content-icon-software-payment-processing',
          url: '/products/payments',
          heapClass: 'nav_paymentproc_v'
        },
        {
          label: 'Toast Now Management App',
          icon: 'before:content-icon-toast-now text-default',
          url: '/products/toast-now',
          heapClass: 'nav_toastnow_v'
        },
        {
          label: 'Toast Mobile Order & Pay®',
          icon: 'before:content-icon-software-mobile-order-pay',
          url: '/products/mobile-order-and-pay',
          heapClass: 'nav_mobileorder_v'
        },
        {
          label: 'Catering & Events',
          icon: 'before:content-icon-software-catering-events',
          url: '/products/catering-and-events',
          heapClass: 'nav_cateringpdp_v'
        }
      ]
    },
    {
      label: 'Marketing Suite',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Email Marketing',
          icon: 'before:content-icon-software-email-marketing',
          url: '/products/toast-marketing',
          heapClass: 'nav_email_v'
        },
        {
          label: 'Loyalty',
          icon: 'before:content-icon-solutions-loyalty',
          url: '/products/loyalty',
          heapClass: 'nav_loyalty_v'
        },
        {
          label: 'Gift Cards',
          icon: 'before:content-icon-solutions-gift-card',
          url: '/products/gift-card',
          heapClass: 'nav_giftcards_v'
        },
        {
          label: 'Toast Tables™',
          icon: 'before:content-icon-solutions-tables',
          url: '/products/toast-tables',
          heapClass: 'nav_tables_v'
        }
      ]
    },
    {
      label: 'Digital Storefront Suite',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Online Ordering',
          icon: 'before:content-icon-software-online-ordering',
          badge: {
            label: 'Popular',
            color: 'bg-yellow-25'
          },
          url: '/products/online-ordering',
          heapClass: 'nav_oo_v'
        },
        {
          label: 'Local by Toast',
          icon: 'before:content-icon-software-toast-takeout',
          url: '/products/toast-takeout',
          heapClass: 'nav_tto_v'
        },
        {
          label: 'Toast Delivery Services©',
          icon: 'before:content-icon-toast-delivery-services',
          url: '/products/toast-delivery-services',
          heapClass: 'nav_tds_v'
        },
        {
          label: 'Grubhub, Uber Eats, DoorDash',
          icon: 'before:content-icon-solutions-third-party-integrations',
          url: '/third-party-delivery-integrations/',
          heapClass: 'nav_3po_v'
        },
        {
          label: 'Websites',
          icon: 'before:content-icon-solutions-websites',
          url: '/products/websites/',
          heapClass: 'nav_websites_v'
        },
        {
          label: 'Branded Mobile App',
          icon: 'before:content-icon-solutions-mobile-app',
          url: '/products/branded-mobile-app',
          heapClass: 'nav_bma_v'
        }
      ]
    },
    {
      label: 'Hardware',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Handheld POS',
          icon: 'before:content-icon-hardware-toast-go',
          url: '/hardware/toast-go',
          heapClass: 'nav_handheldpos_v'
        },
        {
          label: 'Self-Ordering Kiosk',
          icon: 'before:content-icon-hardware-kiosk',
          url: '/hardware/restaurant-kiosk',
          heapClass: 'nav_kiosk_v'
        },
        {
          label: 'Kitchen Display System',
          icon: 'before:content-icon-hardware-flex-for-kitchen',
          url: '/hardware/kitchen-display-system',
          heapClass: 'nav_kds_v'
        }
      ]
    },
    {
      label: 'Management Suite',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Benchmarking',
          icon: 'before:content-icon-solutions-manage-your-team',
          url: '/products/benchmarking',
          heapClass: 'nav_benchmarking_v'
        },
        {
          label: 'Multilocation management',
          icon: 'before:content-icon-multi-location-management',
          url: '/products/multi-location-management',
          heapClass: 'nav_multilocationmanagement_v'
        },
        {
          label: 'Integrations',
          icon: 'before:content-icon-solutions-third-party-integrations',
          url: '/integrations',
          heapClass: 'nav_integrations_v'
        }
      ]
    },
    {
      label: 'Supplier & Accounting Suite',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'xtraCHEF Cost Analytics',
          icon: 'before:content-icon-solutions-xtraChef',
          url: '/products/xtrachef',
          heapClass: 'nav_xtrachef_v'
        },
        {
          label: 'Inventory Management',
          icon: 'before:content-icon-inventory-clipboard',
          url: '/products/inventory-management',
          heapClass: 'nav_inventory_v'
        }
      ]
    },
    {
      label: 'Payroll Suite',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Payroll',
          icon: 'before:content-icon-software-payroll',
          badge: {
            label: 'Popular',
            color: 'bg-yellow-25'
          },
          url: '/products/payroll',
          heapClass: 'nav_payroll_v'
        },
        {
          label: 'Pay Card & PayOut',
          icon: 'before:content-icon-pay-card',
          url: '/products/toast-pay-card-and-pay-out',
          heapClass: 'nav_pcpo_v'
        }
      ]
    },
    {
      label: 'Team Management Suite',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Tips Management',
          icon: 'before:content-icon-solutions-manage-your-team',
          url: '/products/toast-tips-manager',
          heapClass: 'nav_tips_v'
        },
        {
          label: 'Scheduling',
          icon: 'before:content-icon-other-calendar',
          url: '/products/restaurant-employee-scheduling-software',
          heapClass: 'nav_scheduling_v'
        }
      ]
    },
    {
      label: 'Access Capital',
      showLabelMobile: true,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Get a Loan',
          icon: 'before:content-icon-capital',
          url: '/products/capital',
          heapClass: ''
        }
      ]
    }
  ]
}

export default Products
